import Cookies from 'js-cookie';
import { stringToBool } from '@/common/utils/string.utils';

export const cookies: Cookies.CookiesStatic = Cookies.withAttributes({
  path: import.meta.env.VITE_APP_COOKIE_PATH as string,
  secure: stringToBool(import.meta.env.VITE_APP_COOKIE_SECURE as string),
  domain: import.meta.env.VITE_APP_COOKIE_DOMAIN as string,
  expires: parseInt(import.meta.env.VITE_APP_COOKIE_EXPIRES as string),
  sameSite: import.meta.env.VITE_APP_COOKIE_SAME_SITE as 'Lax' | 'Strict' | 'None',
});
